import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    header: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(12),
      justifyContent: "space-between",
      flexWrap: "nowrap",
      marginBottom: theme.spacing(12),
    },
    buttonWrapper: {
      display: "flex",
      flexWrap: "nowrap",
    },
    addBtn: {
      marginLeft: theme.spacing(12),
    },
    emptyState: {
      background: theme.gray50,
      borderRadius: "8px",
      border: `1px solid ${theme.gray200}`,
    },
    separator: {
      width: "100%",
      height: "1px",
      backgroundColor: theme.gray200,
    },
  }),
);
